import * as React from 'react';
import { getStoreState, storeDispatch } from '../state/Store';
import * as Actions from '../state/actions';
import { canHover } from 'utils';
import { ButtonIcon } from './components/ButtonIcon';

export const TemplateUISoundtrackView: React.FunctionComponent = () => {
  const { soundtrack } = getStoreState().flyer;

  const removeSoundtrack = React.useCallback(() => {
    storeDispatch(Actions.removeSoundtrack());
  }, []);

  return (
    <div className={`template-ui-item template-ui-item--soundtrack`}>
      {soundtrack !== null ? (
        <>
          <div className="template-ui-header">
            <span>Soundtrack</span>
          </div>
          <div
            className="soundtrack-preview"
            onClick={() => storeDispatch(Actions.showMusicSourceSelection())}
          >
            <img
              src={soundtrack.thumbUrl || '/media/default-soundtrack-cover.png'}
              // crossOrigin="anonymous"
            />
            <div className="content">
              <div className="title">{soundtrack.title || 'Untitled'}</div>
              {soundtrack.artist && (
                <div className="artist">{soundtrack.artist}</div>
              )}
            </div>
          </div>
          {canHover() ? (
            <div className="close-btn" onClick={removeSoundtrack} />
          ) : (
            <div className="touch-close" onClick={removeSoundtrack}>
              <ButtonIcon
                icon="delete"
                onClick={() => {
                  //
                }}
              />
            </div>
          )}
        </>
      ) : (
        <button
          className="primary medium"
          onClick={() => storeDispatch(Actions.showMusicSourceSelection())}
        >
          Add soundtrack
        </button>
      )}
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/controller/TemplateUISoundtrack.tsx